module.exports = __webpack_public_path__ + "static/sonya-57dfecbcff936bc96bbdd47b667fa8c3.png";